import { render, staticRenderFns } from "./Farms.vue?vue&type=template&id=7d94385f&"
import script from "./Farms.vue?vue&type=script&lang=ts&"
export * from "./Farms.vue?vue&type=script&lang=ts&"
import style0 from "./farms.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports